@if (data !== null) {
  <bp-modal-header class="font-semibold" [title]="'summary_sub_header' | translate">
    <a right class="hover-pointer" (click)="close()" data-dismiss="modal" (keydown.enter)="close()" [tabIndex]="0">
      {{ "cancel" | translate }}
    </a>
  </bp-modal-header>
  @if ({ flag: cfdFlag$ | async }; as cfdFlagObject) {
    <div class="bp-modal-body">
      <div class="bp-modal-body-section mod-wide pt-25 pb-0">
        <!--the buy/sell checks can be removed again once all trade flows have been reworked!!! The background for summary should then be grey for all trade summaries.-->
        <div class="summary-grid">
          <summary-grid
            step="1"
            [titleKey]="getSummaryTitle(1)"
            class="summary-grid-item"
            [cssHover]="true"
            (onStepClick)="setEdit($event)">
            <ng-container iconContainer>
              <div class="summary-card__currency-symbol mb-10">
                <span class="asset-tile-currency-icon">
                  <img
                    [src]="asset?.getLogo()"
                    [style.width.px]="42"
                    (error)="img.src = asset?.getDefaultLogo()"
                    alt="{{ 'logo_alt_text' | translate }}"
                    #img />
                </span>
              </div>
            </ng-container>
            <ng-container detailsContainer>
              <span class="summary-card__text">{{ asset?.getName() }}</span>
              <br />
              <span class="text-small-black">{{ asset?.getSymbol(false, true) }}</span>
            </ng-container>
          </summary-grid>
          <summary-grid
            step="2"
            [titleKey]="getSummaryTitle(2)"
            class="summary-grid-item"
            [cssHover]="true"
            (onStepClick)="setEdit($event)">
            <ng-container iconContainer>
              <div class="summary-card__currency-symbol mb-10">
                <div class="asset-tile-fiat-icon">
                  <img
                    [src]="fiat.getLogo()"
                    [style.width.px]="42"
                    (error)="img.src = fiat.getDefaultLogo()"
                    alt="{{ 'logo_alt_text' | translate }}"
                    #img />
                </div>
              </div>
            </ng-container>
            <ng-container detailsContainer>
              <strong>{{ getFiatName(fiat) }}</strong>
            </ng-container>
          </summary-grid>
          <summary-grid
            step="3"
            [titleKey]="getSummaryTitle(3)"
            class="summary-grid-item"
            [cssHover]="true"
            [cssFaded]="showDisabledRefresh()"
            (onStepClick)="setEdit($event)">
            <!-- Main amount -->
            <ng-container iconContainer>
              @if (!isIndexTrade()) {
                <div class="text-big-black line-height-26 pb-5">
                  <strong>{{ cryptoStringArray[0] + cryptoStringArray[1] }}</strong>
                  <span class="font-size-13">{{ cryptoStringArray[2] }}</span>
                  @if (
                    asset?.getCurrencyType() !== tradableType.SECURITY_TOKEN) {
                    {{
                    data.getAmountTradable()
                    | tradable_precision_symbol: { id: asset.getId(), onlyUnit: true }
                    }}
                  } @else {
                    {{ (+data.getAmountTradable() !== 1 ? "fma_unit_other" : "fma_unit_one") | translate }}
                  }
                </div>
              }
              @if (isIndexTrade()) {
                <div class="text-big-black line-height-26 pb-5">
                  <strong>
                    {{
                    data.getAmountFiat()
                    | fiat_precision_symbol: { id: fiat.getId(), currencies: [fiat], symbol: true }
                    }}
                  </strong>
                </div>
              }
            </ng-container>
            @if (!isIndexTrade()) {
              <ng-container detailsContainer>
                <div [ngClass]="{ 'opa-50': showDisabledRefresh() }">
                  <!-- Fees -->
                  <div class="text-small-black mt-5">
                    &asymp;&nbsp;
                    {{
                    getOfferFiatAmount()
                    | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat] }
                    }}
                    <span>
                      {{
                      (isDerivative() ? "inkl_spread_translation" : "inkl_fees_translation")
                      | translate
                      }}
                    </span>
                  </div>
                  <!-- Price / ratio -->
                  <div class="text-small-gray text-center">
                    @if (
                      asset?.getCurrencyType() !== tradableType.SECURITY_TOKEN) {
                      {{ 1 | tradable_precision_symbol: { id: asset.getId(), removePrecision: true } }}
                    } @else {
                      1 {{ "fma_unit_one" | translate }}
                    }
                    &asymp;
                    {{
                    getRecentPrice()
                    | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat, asset] }
                    }}
                  </div>
                </div>
              </ng-container>
            }
            <!-- Refresh offer -->
            @if (showTimer()) {
              <ng-container additionalContainer>
                <!-- Timer & button link -->
                @if (!showDisabledRefresh()) {
                  <div class="text-center">
                    <svg-inline
                      class="invert-svg-fill"
                      src="/assets/images/icon-offer-timer.svg"
                      alt="{{ 'info_icon_alt_text' | translate }}" />
                    <strong>{{ time | async }}s</strong>
                    <a (click)="userManualAction(); $event?.stopPropagation()" class="ml-5">
                      <span class="text-small-green">{{ "summary_new_offer" | translate }}</span>
                    </a>
                  </div>
                } @else {
                  @if (showGetOfferButton) {
                    <div class="text-center">
                      <button
                        class="btn btn-primary font-size-14 font-semibold"
                        (click)="userManualAction(true); $event?.stopPropagation()">
                        {{ "summary_new_offer" | translate }}
                      </button>
                    </div>
                  }
                }
                <!-- Button only -->
              </ng-container>
            }
          </summary-grid>
        </div>
      </div>
      <!-- Instant Trade Bonus -->
      <!-- TODO: remove this after fee benefit introduced -->
      @let feeTransparencyEnabled = feeTransparencyEnabled$ | async;
      @let visionBenefitFF = visionBenefitFF$ | async;
      @if (!visionBenefitFF) {
        <span class="bp-modal-body-upper mb-20">
          <instant-trade-bonus [tradeData]="itbData" [step]="ITBStep.SUMMARY"></instant-trade-bonus>
        </span>
      }
      @if (feeTransparencyEnabled && isSell()) {
        <!-- Fee transparency and new TW display-->
        <div class="collapsible-wrapper">
          @if (data?.getFee()?.isFeeTransparent) {
            <!-- VSN Fee benefit toggle -->
            @if (
              visionBenefitFF &&
              vsnFeeBenefit?.vsnFeeCollection &&
              isSell() &&
              asset?.getCurrencyType() !== tradableType.INDEX
              ) {
              <web3-vision-optin-toggle [vm]="vsnFeeBenefit" (onToggle)="onVSNToggle($event)" />
            }
            <!-- VSN Fee benefit toggle -->
            <collapsible-container-ui>
            <h3 heading class="price-guarateed">
              <span>{{ "trans_fee_price_guaranteed" | translate }}</span
                ><span
                ><bp-icon size="16" icon="checkmark-starburst" theme="regular" class="icon"></bp-icon
              ></span> </h3
              ><span action class="fee-included">{{ "trans_fee_included" | translate }}</span>
              <!-- data -->
              <fee-transparency-trade-data-ui
                [fiat]="fiat"
                [tradable]="tradable"
                [data]="data"
              [isTaxable]="taxWithheld?.isTaxable"></fee-transparency-trade-data-ui>
            </collapsible-container-ui>
          }
          <!-- if is taxable -->
          @if (taxWithheld?.isTaxable) {
            <collapsible-container-ui>
            <h3 heading class="price-guarateed">{{ "tax_details" | translate }}</h3>
            <!-- content -->
            <!-- Tax Whitheld object is NULL(case for BCI) OR (Tax Whiheld Object is not Null and tax_amount_fiat>=0 = show blue info box variation-->
            @if (
              (taxWithheld?.isTaxable && !taxWithheld.tax) ||
              (+taxWithheld?.tax?.taxAmountFiat >= 0 && taxWithheld?.tax?.isTaxServiceAvailable)
              ) {
              <tax-info-box-ui
                [text1]="'tw_possible_taxable_heading' | translate"
                [text2]="'tw_possible_taxable_detail' | translate"
                [showLink]="true"
              [linkLabel]="'more_info_tooltip_bfc' | translate"></tax-info-box-ui>
            }
            <!-- Tax Whiheld Object is not Null and is_tax_service_available": false = show offline info box orange box variation (offline)-->
            @if (taxWithheld.tax?.isTaxServiceAvailable === false && taxWithheld?.isTaxable) {
              <tax-info-box-ui
                [showWarning]="true"
                [text1]="'tw_warning_heading' | translate"
                [text2]="'tw_warning_message' | translate: [fiat.getSymbol()]"
                [showLink]="true"
              [linkLabel]="'details_tx_item' | translate"></tax-info-box-ui>
            }
          </collapsible-container-ui>
        }
      </div>
      <!-- Fee transparency and new TW display-->
    } @else {
      <!-- Tax Withheld Summary UI LEGACY -->
      @if (taxWithheld; as taxObj) {
        <div class="tax-withheld-summary-wrapper">
          <!-- isTaxable is TRUE and Tax Whitheld object is NULL(case for BCI) OR (Tax Whiheld Object is not Null and tax_amount_fiat>=0 = show blue info box-->
          @if (
            (taxObj?.isTaxable && !taxObj.tax) ||
            (taxObj?.isTaxable && +taxObj?.tax?.taxAmountFiat >= 0 && taxObj?.tax?.isTaxServiceAvailable)
            ) {
            <tax-possible-taxable-info-legacy-ui
              [showLink]="true"
            ></tax-possible-taxable-info-legacy-ui>
          }
          <!-- isTaxable is TRUE and Tax Whiheld Object is not Null and is_tax_service_available": false = show offline info box orange box-->
          @if (taxObj.tax?.isTaxServiceAvailable === false && taxObj?.isTaxable) {
            <tax-offline-info-legacy-ui
              [showLink]="true"
            [walletName]="fiat.getSymbol()"></tax-offline-info-legacy-ui>
          }
        <!-- </ng-template> -->
      </div>
    }
    <!-- Tax Withheld Summary UI -->
  }
  <!-- CashPlus overview-->
  @if (isCashPlus && isBuy() && isBalanceLessThanAmount()) {
    @if (cashPlusAsset; as vm) {
      @if (vm.isEligible) {
        <div class="cashplus-overview-container">
          <cashplus-summary-overview
            [vm]="vm"
            [fiat]="fiat"
            [offer]="data"
            [isLessThanAmount]="isBalanceLessThanAmount()">
            <!-- toggle goes here -->
            <bp-switch [model]="this" field="cashplus_toggle" [disabled]="showDisabledRefresh()">
              <div left>
                <span>{{ "cash_plus_legal" | translate }}</span>
              </div>
            </bp-switch>
            <!-- toggle goes here -->
          </cashplus-summary-overview>
        </div>
      }
    }
  }
  <!-- TODO: CFD CLEANUP, Remove flag-->
  @if (cfdFlagObject.flag && isBuy() && isLeveragedToken()) {
    <div class="leveraged-warning-box">
      {{ "cfd_risk_text" | translate }}
    </div>
  }
  <!-- L-tokens borrow info -->
  @if (isLeveragedToken()) {
    @if (leverageTokenViewModel$ | async; as vm) {
      <div class="l-token-info-wrapper">
        <leverage-token-info-summary
          [vm]="vm"
          [offerAmount]="data.getAmountFiat()"
          [currentBorrow]="data.getCurrentBorrow()"
          [isBuy]="isBuy()"
          [futurePosition]="data.getFutureBorrow()"
          [cfdEnabled]="cfdFlagObject.flag">
        </leverage-token-info-summary>
      </div>
    }
  }
  <!-- L-tokens borrow info -->
  <!--
  *
  *
  *   BOTTOM
  *
  *
  -->
  <div class="bp-modal-body-upper pt-0 mb-10">
    @if (bundles$ | async; as bundles1) {
      <!-- dynamic -->
      <terms-and-conditions-updates
        [bundles]="bundles1"
        [tradable]="tradable"
        (onTermsBuilding)="setTermsLoadingFinished()"
      [urlLeverageToken]="(leverageTokenViewModel$ | async)?.documentUrl"></terms-and-conditions-updates>
    } @else {
      <loading-spinner></loading-spinner>
    }
    <!-- static -->
    @if (isSecurityToken) {
      <p class="security-tokens-disclaimer">
        {{ "security_tokens_summary_screen_counterparty_info" | translate }}
      </p>
    }
  </div>
  @if (
    visionBenefitFF &&
    vsnBenefitTotalVM?.vsnFeeCollection &&
    isSell() &&
    asset?.getCurrencyType() !== tradableType.INDEX
    ) {
    <div class="collapsible-wrapper no-border">
      <vision-summary-total-ui [vm]="vsnBenefitTotalVM" [selectedCurrency]="data?.getSelectedCurrency()" />
    </div>
  }
  <div class="text-center mb-30" [ngClass]="{ 'mb-15': showDerivativeFooter() }">
    <button
      class="btn btn-primary mod-send btn-summary btn-lg mb-0"
      [ngClass]="{ disabled: isButtonDisabled }"
      [disabled]="isButtonDisabled"
      type="button"
      (click)="acceptOffer()">
      @if (isLeveragedToken()) {
        {{ "leverage_token_trade_summary_" + leveragedTokenSuffix | translate }}
      } @else {
        {{ "finish_" + data.getType() + "_button" | translate }}
      }
    </button>
    @if (showDerivativeFooter() || (isLeveragedToken() && cfdEnabled)) {
      <div
        class="trade-modal_powered_by_stocks">
        {{ "stocks_powered_by" | translate }}
      </div>
    }
  </div>
</div>
}
}
